import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `ControlMorfologico/addControlMorfologico`, method: 'POST', body: values, token: token})
}
